import React from "react";
import styled from "styled-components";
import Marjo from '../../assets/newSvg/marjo.svg'
import khadamat from '../../assets/newSvg/khadamat.svg'
import Trunck from '../../assets/newSvg/trunck.svg'
import Zemanat from '../../assets/newSvg/zemanat.svg'

const Style = styled.div`
    margin-top: 1rem;
    position: relative;
    .garant-title{
        font-size: 1.25rem;
        font-weight:700;
        color: var(--gray-10);
        position: absolute;
        top: -1rem;
    }
    .garant{
        display: flex;
        flex-direction:column ;
        position: relative;
        justify-content: baseline;
        align-items: center;
        text-align: center;
        padding: 0 1rem;
        width: calc(100% - 2rem);
        border-left: var(--border-style-2);
        .garanty-svg{
            width: 2.5rem; 
            aspect-ratio: 1;  
            margin-bottom: 0.5rem;
        }
        .garanty-tit{
            font-size: 0.87rem;
            font-weight: 500;
            color: var(--text-5);
            margin-bottom: 0.25rem;
        }
        .garanty-desc{
            font-size: 0.75rem;
            font-weight: 400;
            color: var(--gray-6);
            flex-wrap: wrap;
            text-align: center;
        }
        :last-child{
            border-left: none;
        }
    }
    @media screen and (max-width:850px){
        .garant-title{
            font-size: 1rem;
        }
        .garant{
            :nth-child(even){
                border-left: none;
            }
            :nth-child(odd){
                border-left: var(--border-style-2);
            }
        }
    }
`

export const Garanty =({classname , title})=>{
    return(
        <Style className={classname}>
            {
                title ? 
                    <h2 className="garant-title">چرا لوکسین لوکس ؟</h2>
                :  ''
            }
            <div className="garant">
            <img src={khadamat} alt='خدمات پس از فروش' className="garanty-svg"/>
            <span className="garanty-tit">خدمات پس از فروش</span>
            <span className="garanty-desc">خدمات پس از فروش تیم پشتیبانی در دسترس</span>
            </div>
            <div className="garant">
            <img src={Zemanat} alt='ضمانت اصالت' className="garanty-svg"/>
            <span className="garanty-tit">ضمانت اصالت</span>
            <span className="garanty-desc">تمامی کالا ها اورجینال و دارای ضمانت اصالت می باشد</span>
            </div>
            <div className="garant">
            <img src={Marjo} alt='ضمانت بازگشت کالا' className="garanty-svg"/>
            <span className="garanty-tit">ضمانت بازگشت کالا</span>
            <span className="garanty-desc">بازگشت کالا تا 2 روز بعد دریافت کالا</span>
            </div>
            <div className="garant">
            <img src={Trunck} alt='ارسال سریع و رایگان' className="garanty-svg"/>
            <span className="garanty-tit">ارسال سریع و رایگان</span>
            <span className="garanty-desc">ارسال رایگان برای تمام خریدهای لوکسین لوکس</span>
            </div>
        </Style>
    )
}